// extracted by mini-css-extract-plugin
module.exports = {"logo":"_2c0ad1d3","chapter":"c72e2d57","chapterTitle":"_5e0ebe7a","chapterDesc":"de526628"};